(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'FitBuilderLodging',
	};

	var images          = [],
		selected_images = [],
		total_photos    = 0;

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		// hotel property lookup
		Adzuki.Typeahead(
			'#fitbuilderlodging-name',
			'/Searches/hotelSearch/',
			function select(item, $self, typeahead) {
				// console.log(item);
				typeahead.setHiddenValue(item.id);

				$('#fitbuilderlodging-name').val(item.name);
				$('#fitbuilderlodging-name').prop('disabled', true);

				setFields(item);
			},
			function template(item) {
				var html;

				if (item.city) {
					html = item.name + ' (' + item.city + ', ' + item.country_code + ')';
				} else {
					html = item.name;
				}

				return html;
			}
		);

		// hotel property reset
		$('#reset-hotel-link').click(function _resetHotel(e) {
			e.preventDefault();

			$('#fitbuilderlodging-name').val('');
			$('#fitbuilderlodging-description').val('');
			$('#fitbuilderlodging-giata_id').val('');
			$('#fitbuilderlodging-address1').val('');
			$('#fitbuilderlodging-address2').val('');
			$('#fitbuilderlodging-city').val('');
			$('#fitbuilderlodging-state').val('');
			$('#fitbuilderlodging-zipcode').val('');
			$('#fitbuilderlodging-phone').val('');
			$('#fitbuilderlodging-lat').val('');
			$('#fitbuilderlodging-lng').val('');
			$('#fitbuilderlodging-image_url').val('');

			$('.reset-hotel').addClass('hidden');
			$('#fitbuilderlodging-name').prop('disabled', false);
			$('.hotel-image').html('');
			$('.hotel-details').addClass('hidden');
		});

		// hotel property images
		$('.hotel-details').on('click', '.fit-builder-hotel-image', function _selectHotel() {
			var image,
				src = $(this).data('src');

			if ($(this).hasClass('fit-builder-hotel-images-active')) {
				$(this).removeClass('fit-builder-hotel-images-active');

				image = selected_images.indexOf(src);

				if (image > -1) {
					selected_images.splice(image, 1);
				}

			} else {
				selected_images.push(src);

				$(this).addClass('fit-builder-hotel-images-active');
			}

			if (selected_images.length > 0) {
				$('.photo-count').html(total_photos + ' - Selected ' + selected_images.length);
			} else {
				$('.photo-count').html(total_photos);
			}

			$('#fitbuilderlodging-image_url').val(JSON.stringify(selected_images));
		});

		// all-inclusive resort selection
		$('.resort-property').on('change', function _geResortDetails() {
			var property_id = $(this).val(),
				description = '',
				phone       = '';

			Adzuki.Ajax.get('/AllInclusiveProperties/getPropertyDetails/' + property_id).then(function success(property) {
				if ($.isEmptyObject(property) === false) {
					description = property.long_description;
					phone       = property.phone;
				}

				// set description
				Adzuki.Editor('#fitbuilderlodging-description', {
					init_instance_callback: function onEditorInit(_editor) {
						_editor.setContent(description);
						$('#fitbuilderlodging-description').val(description);
					},
				});

				// set phone
				$('#fitbuilderlodging-phone').val(phone);
			});
		});
	};

	form.success = function success(response)
	{
		var form_data,
			component_index;

		if ($('#fitbuilderlodging-adding').val() === '1') {
			if (!Adzuki.Form.hasError(response)) {
				if ($('#fit-builder-component-index')) {
					component_index = $('#fit-builder-component-index').val();
				}

				form_data = $('#fit-builder-lodging').serialize();

				$('#saved_details_' + component_index).val(form_data);
				$('#fit-builder-details-type-message-' + component_index).removeClass('hidden');
				$('.modal').modal('hide');
			}
		} else {
			// eslint-disable-next-line no-lonely-if
			if (!Adzuki.Form.hasError(response)) {
				window.location.href = response['data'];
				return true;
			}
		}
	};

	function setFields(hotel) {
		var has_stuff   = false,
			image_html  = '',
			description = '';

		$('#fitbuilderlodging-name').val(hotel.name);
		$('#fitbuilderlodging-giata_id').val(hotel.giata_id);
		$('#fitbuilderlodging-address1').val(hotel.street_address_1);
		$('#fitbuilderlodging-address2').val(hotel.street_address_2);
		$('#fitbuilderlodging-city').val(hotel.city);
		$('#fitbuilderlodging-state').val(hotel.state_prov);
		$('#fitbuilderlodging-zipcode').val(hotel.postal_code);
		$('#fitbuilderlodging-phone').val(hotel.phone);
		$('#fitbuilderlodging-lat').val(hotel.latitude);
		$('#fitbuilderlodging-lng').val(hotel.longitude);

		if (hotel.giata_id) {
			Adzuki.Ajax.get(Adzuki.base_uri + '/HotelEngine/hotelMetaData/' + hotel.giata_id)
			.then(function success(response) {
				if (response.metadata.images) {
					response.metadata.images.forEach(function _getImages(image, i) {
						images.push(image.medium);

						image_html += '<div class="fit-builder-hotel-image fb-has-hover" data-src="' + image.medium + '" style="background-image: url(' + image.medium + '), url(' + Adzuki.base_uri + '/images/noimage-available.png")"><span class="edit-overlay" style="pointer-events:none;"></span><i class="fas fa-check fa-2x"></i></div>';
					});

					if (images.length > 0) {
						$('.fit-builder-hotel-images').html(image_html);
						total_photos = images.length;
						$('.photo-count').html(images.length);
					} else {
						total_photos = 0;
					}
				}

				$('.photo-count').html(' - ' + total_photos);

				if ($.isEmptyObject(response.metadata.property) === false) {
					// set the component description to the property room description
					if (response.metadata.property.description_rooms !== '' && response.metadata.property.description_rooms !== 'undefined') {
						description = description + '<strong>About the Property</strong><br>' + response.metadata.property.description_rooms + '<br><br>';
					}

					// and amenities description
					if (response.metadata.property.description_amenities !== '' && response.metadata.property.description_amenities !== 'undefined') {
						description = description + '<strong>Property Amenities</strong><br>' + response.metadata.property.description_amenities + '<br><br>';
					}
				}

				// set description editor content
				Adzuki.Editor('#fitbuilderlodging-description', {
					init_instance_callback: function onEditorInit(_editor) {
						_editor.setContent(description);
						$('#fitbuilderlodging-description').val(description);
					},
				});
			});

			has_stuff = true;
		} else {
			$('.fit-builder-hotel-images').html('<img src="' + Adzuki.base_uri + '/images/noimage-available.png" class="img-responsive">');
		}

		if (has_stuff === true) {
			$('.hotel-details').removeClass('hidden');
		}

		$('.reset-hotel').removeClass('hidden');
	}
}(jQuery, window.Adzuki || {}));